import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KbDrugGroupModel } from '@medindex-webapi';

@Component({
  selector: 'app-indications-tab',
  templateUrl: './indications-tab.component.html',
  styleUrls: ['./indications-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndicationsTabComponent {
  @Input() drugInfluenceGroups: KbDrugGroupModel[] = [];

  getDrugsListFromGroup(drugGroup: KbDrugGroupModel): string[] {
    return (
      drugGroup.kbDrugInfluenceItems?.map(
        (item) =>
          `${item.title} (${
            item.influenceLevel === 'Low'
              ? 'Понижает значение'
              : 'Повышает значение'
          })`
      ) ?? []
    );
  }
}
